// Tokens de design — fonte única de verdade para cor e tipografia.
// Valores literais extraídos da Seção 6 (Fundação Visual) de
// `_bmad-output/planning-artifacts/ux-design-specification.md`.
// Não inventar/aproximar tons aqui — qualquer novo valor precisa vir da spec de UX.

export const colors = {
  light: {
    primary: {
      main: "#1B3A4B", // Azul-Empório
      dark: "#10262F",
    },
    secondary: {
      main: "#C2703D", // Âmbar-Machado
    },
    background: {
      default: "#F6F7F8", // Branco-Gelo
      paper: "#FFFFFF",
    },
    success: {
      main: "#2E7D45",
    },
    error: {
      main: "#B3261E",
    },
    warning: {
      main: "#B8860B",
    },
    text: {
      primary: "#1B221E",
      secondary: "#5B6660",
    },
  },
  dark: {
    primary: {
      main: "#4C86A0",
      dark: "#2D6478",
    },
    secondary: {
      main: "#E08F5B",
    },
    background: {
      default: "#14202A", // Azul-Carvão
      paper: "#1C2833",
    },
    success: {
      main: "#4CAF6D",
    },
    error: {
      main: "#E5534B",
    },
    warning: {
      main: "#D6A93A",
    },
    text: {
      primary: "#F3EFE8",
      secondary: "#B8C2BB",
    },
  },
};

// Display/Títulos: Fraunces (serifada). UI/Corpo/Dados: Inter.
export const fontFamily = {
  display: "'Fraunces', serif",
  body: "'Inter', sans-serif",
};

// Escala tipográfica — base 16px, razão 1.25 (Seção 6.2).
export const typeScale = {
  h1: "40px",
  h2: "32px",
  h3: "25px",
  h4: "20px",
  body1: "16px",
  body2: "14px",
  caption: "12px",
};

// Unidade base de espaçamento (Seção 6.3) — múltiplos de 8px, padrão MUI.
export const spacingUnit = 8;

// Valores monetários e códigos (Seção 6.2) — alinhamento tabular de colunas
// de valor no DataGrid e relatórios financeiros. Aplicar via `sx` nos
// elementos/tabelas que exibem números, não globalmente na tipografia base.
export const numericFontVariant = {
  fontVariantNumeric: "tabular-nums",
};
